export class Codificador {
  id: any;
  nombre: string;
}
